export type ReturnBlockedCustomer = {
  orderId: string;
  orderNumber: string;
  customerId: string | null;
  email: string | null;
  customerName: string | null;
};

export type ReturnCustomerRestrictions = {
  storeId: string;
  enabled: boolean;
  customerTags: string[];
  blockedEmails: string[];
  blockedCustomers: ReturnBlockedCustomer[];
};

export const getReturnCustomerRestrictionErrorCode = (
  error: unknown,
): string => {
  const errors = (error as { graphQLErrors?: any[] } | null)?.graphQLErrors;
  if (!Array.isArray(errors)) return '';
  return (
    errors.find((item) => typeof item?.extensions?.code === 'string')
      ?.extensions.code || ''
  );
};

export const validReturnBlockedCustomer = (
  value: any,
): value is ReturnBlockedCustomer =>
  typeof value?.orderId === 'string' &&
  Boolean(value.orderId) &&
  typeof value.orderNumber === 'string' &&
  Boolean(value.orderNumber) &&
  (value.customerId === null || typeof value.customerId === 'string') &&
  (value.email === null || typeof value.email === 'string') &&
  (value.customerName === null || typeof value.customerName === 'string') &&
  Boolean(value.customerId || value.email);

export const normalizeReturnCustomerEmails = (emails: string[]): string[] =>
  Array.from(
    new Set(emails.map((email) => email.trim().toLowerCase()).filter(Boolean)),
  );

export const normalizeReturnBlockedCustomers = (
  customers: ReturnBlockedCustomer[],
): ReturnBlockedCustomer[] =>
  customers.map((customer) => ({
    orderId: customer.orderId,
    orderNumber: customer.orderNumber,
    customerId: customer.customerId,
    email: customer.email?.trim().toLowerCase() || null,
    customerName: customer.customerName,
  }));

export const normalizeReturnCustomerTags = (
  tags: string[] | null | undefined,
): string[] => {
  if (!Array.isArray(tags)) return [];
  const unique = new Map<string, string>();
  tags.forEach((rawTag) => {
    const tag = rawTag.trim();
    if (tag && !unique.has(tag.toLowerCase()))
      unique.set(tag.toLowerCase(), tag);
  });
  return Array.from(unique.values());
};
